import axios from 'axios'
import { format } from 'date-fns'
import { getTotalByMonth } from './lib/callChartAPI'

const getMonthlyStatusData = async (currentDate, storeId) => {
  const response = await getTotalByMonth('tm_monthly_status', format(currentDate, 'yMM'), storeId)

  return {
    'successfully-parsed': response.data[0] || 0,
    'unsupported-category': response.data[3] || 0,
    'missing-measurements': response.data[4] || 0,
    'no-measurements': response.data[5] || 0,
    'vs-optimization-in-progress': response.data[-1] || 0,
    'total': Object.values(response.data).reduce((t, n) => t + n) || 0
  }
}

const getLatestItemsData = async (currentDate, storeId) => {
  const response = await getTotalByMonth('tm_latest_items', format(currentDate, 'yMM'), storeId)
  const splitBySize = (original, statusKey) => {
    let newArray = []
    original.forEach(org => {
      let orgObject = {
        ...org,
        statusKey
      }
      delete orgObject.sizes
      if (!org.sizes) {
        newArray.push(orgObject)
        return
      }
      Object.keys(org.sizes).forEach(size => {
        let newSizeObject = {
          sizeName: size,
          sizes: org.sizes[size]
        }
        newArray.push({
          ...orgObject,
          ...newSizeObject
        })
      })
    })
    return newArray
  }

  return {
    'successfully-parsed': splitBySize(response.data[0], 'successfully-parsed') || [],
    'unsupported-category': splitBySize(response.data[3], 'unsupported-category') || [],
    'missing-measurements': splitBySize(response.data[4], 'missing-measurements') || [],
    'no-measurements': splitBySize(response.data[5], 'no-measurements') || [],
    'vs-optimization-in-progress': splitBySize(response.data[-1], 'vs-optimization-in-progress') || []
  }
}

const instanceForAPI = axios.create({
  baseURL: process.env['VUE_APP_LAMBDA_API'],
  headers: {}
})

const getDownloadLink = async (currentDate, storeId) => {
  const response = await instanceForAPI.get(`/download_items/${storeId}/${format(currentDate, 'yyyy/MM')}`)
  return response.data
}

export default async (chartName, currentDate, storeId) => {
  if (chartName === 'tm_monthly_status') {
    return getMonthlyStatusData(currentDate, storeId)
  }
  if (chartName === 'tm_latest_items') {
    return getLatestItemsData(currentDate, storeId)
  }

  return getDownloadLink(currentDate, storeId)
}
